import { client } from "utils/axios"
import * as yup from "yup";
import { showMessage } from "store/modules/Message";

export async function deleteCategories(categoryId) {
    await client.delete(`category/${categoryId}`);
};
export async function getAllCategoriesType() {
    const { data } = await client.get("/typeCategory");
    return data;
}
export async function getAllCategories() {
    const { data } = await client.get("/category");
    return data;
}
export async function getAllCategorias() {
    const { data } = await client.get("/category");
    return data;
}

export const validationSchemaCategories = yup.object({
    name: yup
        .string("Ingresa nombre de Categories")
        .required("Campo Requerido"),
    code: yup
        .string("Ingresa Codigo")
        .required("Campo Requerido"),
    type: yup.mixed().required("El tipo es requerido").test('is-selected', 'El tipo es requerido', value => value !== null && value !== undefined && value !== '')

});
export const createCategories = async (category, dispatch) => {
    try {
        await client.post("category", { ...category, type: { id: category.type.id } });
        dispatch(
            showMessage({
                message: "Categoría agregada con éxito",
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            })
        );
        return true;
    } catch (error) {
        dispatch(
            showMessage({
                message: error?.response?.data?.message || "Ocurrió un error al agregar la categoría",
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                },
            })
        );
        return false;
    }
};

export const modifyCategories = async (category, dispatch) => {
    try {
        await client.put("category", { ...category, type: { id: category.type.id } });

        dispatch(
            showMessage({
                message: `Categoría "${category.name}" modificada con éxito`,
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );
        return true;
    } catch (error) {
        dispatch(
            showMessage({
                message: error?.response?.data?.message || `Ocurrió un error al modificar la categoría "${category.name}"`,
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );
        return false;
    }
};
